// import loadStripe without side effects to delay loading it until loadStripe is called
// https://github.com/stripe/stripe-js/blob/master/README.md#importing-loadstripe-without-side-effects
import { loadStripe } from '@stripe/stripe-js/pure';

// disable advanced fraud signals
loadStripe.setLoadParameters({ advancedFraudSignals: false });

let _stripePromise;

/**
 * @param {Object} options
 * @param {string} options.stripeAccount
 * if stripe account is not provided, it will use our own stripe account to initialize the stripe instance
 * allowing us to display stripe elements etc before the merchant has connected their stripe account
 * @param {boolean} options.isTestMode
 * mode has to drive the key: `?testing=true` only unlocks draft previews now, and
 * a draft preview is a live checkout, so keying off it would hand a test key to a
 * real payment.
 * @returns {Promise<Stripe>}
 */
const getStripe = ({ stripeAccount, isTestMode, publicKey, publicKeyTest }) => {
  if (!_stripePromise) {
    if (isTestMode) {
      _stripePromise = loadStripe(publicKeyTest, {
        ...(stripeAccount && { stripeAccount }),
      });
    } else {
      _stripePromise = loadStripe(publicKey, {
        ...(stripeAccount && { stripeAccount }),
      });
    }
  }

  return _stripePromise;
};

export default getStripe;
